import * as React from "react";
import { Menu } from "lucide-react";
import CCLogo from "../../images/cc_logo.svg";

function Logo() {
  return (
    <a
      href="/"
      className="flex items-center no-underline"
    >
      <img
        src={CCLogo}
        alt="Chapter Chronicles Logo"
        className="w-[60px] h-[60px] scale-200 origin-center"
      />
      <span className="ml-2 font-bold text-white text-lg hidden md:block">
        Chapter Chronicles
      </span>
    </a>
  );
}

const pages = [
  { label: "Discover Authors", path: "https://app.chapterchronicles.com/authors", external: true },
  { label: "For Authors", path: "/for-authors" },
  { label: "Patreon Alternative", path: "/for-patreon-authors" },
  { label: "Pricing", path: "/pricing" },
  { label: "Blog", path: "/blog" },
];

function ResponsiveAppBar() {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <header className="bg-[#1E1E1E] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16">
          {/* Desktop Logo */}
          <div className="hidden md:flex mr-2">
            <Logo />
          </div>

          {/* Mobile Menu Button */}
          <div className="flex md:hidden flex-grow-0">
            <button
              aria-label="navigation menu"
              aria-controls="mobile-menu"
              aria-expanded={mobileOpen}
              onClick={() => setMobileOpen((v) => !v)}
              className="text-white p-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              <Menu className="w-6 h-6" />
            </button>
          </div>

          {/* Mobile Logo */}
          <div className="flex md:hidden flex-1 ml-1">
            <Logo />
          </div>

          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex flex-1 ml-4 gap-4">
            {pages.map((page) => (
              <a
                key={page.path}
                href={page.path}
                className="text-white/80 hover:text-white transition-colors duration-150 text-base font-medium py-2"
              >
                {page.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex items-center gap-2">
            <a
              href="https://app.chapterchronicles.com/auth/login"
              className="text-white font-medium text-base px-4 py-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              Login
            </a>
            <a
              href="https://app.chapterchronicles.com/auth/signup"
              className="inline-flex items-center justify-center bg-primary text-white h-10 px-8 rounded-lg font-semibold text-base hover:bg-primary-hover hover:-translate-y-px hover:shadow-md transition-all duration-200"
            >
              Sign Up Free
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div id="mobile-menu" className="md:hidden border-t border-white/10">
          <div className="px-4 py-2 flex flex-col">
            {pages.map((page) => (
              <a
                key={page.path}
                href={page.path}
                onClick={() => setMobileOpen(false)}
                className="text-white/80 hover:text-white py-3 text-base transition-colors"
              >
                {page.label}
              </a>
            ))}
            <hr className="border-white/10 my-1" />
            <a
              href="https://app.chapterchronicles.com/auth/login"
              onClick={() => setMobileOpen(false)}
              className="text-white/80 hover:text-white py-3 text-base transition-colors"
            >
              Login
            </a>
            <a
              href="https://app.chapterchronicles.com/auth/signup"
              onClick={() => setMobileOpen(false)}
              className="text-primary font-semibold py-3 text-base"
            >
              Sign Up Free
            </a>
          </div>
        </div>
      )}
    </header>
  );
}

export default ResponsiveAppBar;
